import React from "react";

type Totals = { calories: number; protein: number; carbs: number; fat: number };
type Targets = {
  calories: number;
  protein: number;
  carbs: number;
  fat: number;
};

export const DailyTotals: React.FC<{ totals: Totals; targets: Targets }> = ({
  totals,
  targets,
}) => {
  const clamp = (n: number) => Math.max(0, Math.min(100, n));
  const toPct = (value: number, target: number) =>
    target > 0 ? Math.round((value / target) * 100) : 0;

  const percent = {
    calories: toPct(totals.calories, targets.calories),
    protein: toPct(totals.protein, targets.protein),
    carbs: toPct(totals.carbs, targets.carbs),
    fat: toPct(totals.fat, targets.fat),
  };

  const bar = (label: string, value: number, target: number, pct: number) => (
    <div key={label} style={styles.barRow}>
      <span style={styles.barLabel}>{label}</span>
      <div style={styles.barTrack} aria-label={`${label} progress`}>
        <div style={{ ...styles.barFill, width: `${clamp(pct)}%` }} />
      </div>
      <span style={styles.barValue}>
        {Math.round(value)}/{target}
      </span>
    </div>
  );

  return (
    <section style={styles.container} aria-label="Daily totals">
      <h3 style={styles.title}>Daily Totals</h3>
      {bar("Calories", totals.calories, targets.calories, percent.calories)}
      {bar("Protein (g)", totals.protein, targets.protein, percent.protein)}
      {bar("Carbs (g)", totals.carbs, targets.carbs, percent.carbs)}
      {bar("Fat (g)", totals.fat, targets.fat, percent.fat)}
    </section>
  );
};

const styles: { [k: string]: React.CSSProperties } = {
  container: {
    padding: 12,
    borderRadius: 8,
    background: "#252525",
    color: "#fff",
    marginTop: 8,
  },
  title: { margin: 0, fontSize: 16, marginBottom: 8 },
  barRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 6,
  },
  barLabel: { width: 120, fontSize: 12, color: "#ddd" },
  barTrack: {
    flex: 1,
    height: 10,
    background: "#3a3a3a",
    borderRadius: 6,
    overflow: "hidden",
  },
  barFill: {
    height: "100%",
    background: "#ff6b35",
  },
  barValue: { width: 80, textAlign: "right", fontSize: 12, color: "#bbb" },
  barPercent: {},
};

export default DailyTotals;
